<template>
  <div class="face-open" data-test="face-open">
    <div class="main">
      <video
        class="video"
        controls="true"
        preload
        autoplay
        src="https://xgj-face.su.bcebos.com/face_in/face_in.m4v"
      ></video>

      <div class="info">
        <div class="b1">一分钟免费搭建刷脸到校通知系统，机构服务天天可见，家长更安心</div>
        <div class="b2">
          <img class="img" src="https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/x3/assets/m/img/teacher/face-001.png" alt="">
          <div class="til">无门槛</div>
          <div class="desc">无需购硬件，下载APP就能用</div>
        </div>
        <div class="b2">
          <img class="img" src="https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/x3/assets/m/img/teacher/face-002.png" alt="">
          <div class="til">易操作</div>
          <div class="desc">操作简单，快速搭建机构刷脸签到系统</div>
        </div>
        <div class="b2">
          <img class="img" src="https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/x3/assets/m/img/teacher/face-003.png" alt="">
          <div class="til">助课消</div>
          <div class="desc">脸到信息同步云校，老师点名更高效</div>
        </div>
        <div class="b2">
          <img class="img" src="https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/x3/assets/m/img/teacher/face-004.png" alt="">
          <div class="til">学员到校，家长知道</div>
          <div class="desc">刷脸照片实时推送，家长更放心</div>
        </div>
      </div>
    </div>

    <div class="footer">
      <van-button
        v-if="isAdmin"
        square round
        block
        type="primary"
        @click="openFace"
        loading-text="开通中..."
        :loading="isSubmit"
        data-test="face-open-btn-submit"
        >
        立即开通脸到
      </van-button>
      <van-button 
        v-else 
        square round 
        block 
        color="var(--g5)"
        >
          请联系管理员开通
        </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "open-accountbook",
  data() {
    return {
      pageTitle: "开通脸到",
      isAdmin: app.teacher.user.admin,
      isSubmit: false, //提交中
    };
  },
  methods: {
    openFace() {
      this.isSubmit = true;
      this.$api
        .faceInOpen()
        .then((res) => {
          if (res.code == 200) {
            app.teacher.user.companyInfoVo.companyAppOpenList.push("FACE_IN");
            this.$toast.success("开通脸到成功");
            setTimeout(() => {
              this.$router.replace(`/face/list`);
            }, 50);
          } else if (res.code == 84001) {
            this.$toast.fail("脸到开通失败，请稍后重试");
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.isSubmit = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.face-open {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  .main {
    flex: 1;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 20);
    overflow: auto;
    .video {
      width: 100%;
      border-radius: 4px;
    }
    .info {
      padding: 0 calc(var(--gap) * 16);
      .b1 {
        margin-bottom: calc(var(--gap) * 36);
        padding-top: calc(var(--gap) * 12);
        font-size:var(--fs-md);
        line-height:var(--lh-lg);
        color: var(--g6);
        // text-align: center;
      }
      .b2 {
        position: relative;
        margin-top: calc(var(--gap) * 24);
        padding-left: calc(var(--w) * 62);
        .img {
          position: absolute;
          top: 0;
          left: 0;
          width: calc(var(--w) * 46);
        }
        .til {
          font-size:var(--fs-ex1);
          line-height:var(--lh-ex1);
          color: var(--g8);
          font-weight: bold;
        }
        .desc {
          padding-top: calc(var(--gap) * 4);
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g6);
        }
      }
    }
  }

  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>